<template>
  <div>
    <div class="body-overlay"></div>

    <div id="side-panel" class="dark">
      <div id="side-panel-trigger-close" class="side-panel-trigger">
        <a href="#"><i class="icon-line-cross"></i></a>
      </div>

      <div class="side-panel-wrap">
        <div class="widget widget_links clearfix">
          <h4>{{ $t('forhairmedical') }}</h4>

          <div style="font-size: 14px; line-height: 1.7;">
            <address style="line-height: 1.7;">
              {{ $t('branchgangnam') }}<br />
              {{ $t('branchgangnamaddr') }}<br />
            </address>
            <address style="line-height: 1.7;">
              {{ $t('branchbusan') }}<br />
              {{ $t('branchbusanaddr') }}<br />
            </address>
            <address style="line-height: 1.7;">
              {{ $t('branchdaegu') }}<br />
              {{ $t('branchdaeguaddr') }}<br />
            </address>
            <div class="clear topmargin-sm"></div>

            <abbr title="Phone Number">Phone:</abbr> (82) 1599-4005<br />
            <abbr title="Email Address">Email:</abbr> admin@forhair.co.kr
          </div>
        </div>

        <div class="widget clearfix">
          <h4>Connect Socially</h4>

          <a
            :href=getFacebookLink()
            class="social-icon si-small si-colored si-facebook"
            title="Facebook"
          >
            <i class="icon-facebook"></i>
            <i class="icon-facebook"></i>
          </a>
          <a
            :href=getYoutubeLink()
            class="social-icon si-small si-colored si-twitter"
            title="youtube"
          >
            <i class="icon-youtube"></i>
            <i class="icon-youtube"></i>
          </a>
          <a
            :href=getInstagramLink()
            class="social-icon si-small si-colored si-instagram"
            title="Instagram"
          >
            <i class="icon-instagram"></i>
            <i class="icon-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidePanel",
  methods: {
    getFacebookLink(){
      // //www.facebook.com/FORHAIRclinicKorea/ en
      if('ko' == this.$i18n.locale)
        return '//www.facebook.com/profile.php?id=100011005694737'
      
      if('vn' == this.$i18n.locale)
        return '//www.facebook.com/vietnam.FORHAIRclinic/';

      return '//www.facebook.com/FORHAIRclinicKorea/'
    },
    getInstagramLink(){
      return 'ko' == this.$i18n.locale ? 
          '//www.instagram.com/forhair_insta' :
          '//www.instagram.com/forhairclinic_korea/';
    },
    getYoutubeLink(){
      return 'ko' == this.$i18n.locale ? 
        '//www.youtube.com/channel/UC_eXwA-sSQzp5ItBqeOXaQA' : 
        '//bit.ly/31fDY1Z';
    }
  }
};
</script>


<style scoped></style>
